/**
 * Converts camelCase field names to readable labels
 * e.g., "externalRewardCategoryId" → "External Reward Category Id"
 */
export const convertFieldNameToLabel = (fieldName: string): string => {
  return fieldName
    .replace(/([A-Z])/g, ' $1')
    .replace(/^./, (str) => str.toUpperCase())
    .trim()
}

/**
 * Formats cents to dollar string with 2 decimal places
 * e.g., 1234 → "12.34"
 */
export const formatCurrency = (cents: number): string => {
  return (cents / 100).toFixed(2)
}

/**
 * Parses dollar string to cents
 * e.g., "12.34" → 1234
 */
export const convertDollarsToCents = (dollarString: string): number => {
  return Math.floor(parseFloat(dollarString) * 100)
}

/**
 * Formats enum values to human-readable labels
 * Replaces underscores and dashes with spaces, applies title case
 * e.g., "FAST_PLAY" → "Fast Play"
 * e.g., "TICKET_COST_MULTIPLIER" → "Ticket Cost Multiplier"
 */
export const formatEnumLabel = (value: string): string => {
  if (!value) {
    return ''
  }

  return value
    .replace(/[_-]/g, ' ')
    .toLowerCase()
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ')
}

/**
 * Checks if a promotion campaign has started
 * Returns true if the start date/time is in the past
 */
export const hasPromotionStarted = (campaign: { startAt?: Date | null }): boolean => {
  if (!campaign?.startAt) {
    return false
  }
  return new Date(campaign.startAt) <= new Date()
}
